import { useFormat } from 'vivat';
import usePayment from '@/usePayment';

const { translate: paymentMethodTranslate } = usePayment();
export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-right',
    },
    orderDate: {
      name: 'สั่งซื้อวันที่',
      width: '6rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    customerName: {
      name: 'ชื่อลูกค้า',
      width: '1.5fr',
    },
    contactTelephone: {
      name: 'เบอร์โทร',
      width: '1fr',
    },
    // area: {
    //   name: 'โซนจัดส่ง',
    //   width: '8rem',
    // },
    address: {
      name: 'ที่อยู่ในการจัดส่ง',
      width: '14rem',
      filter: (val: any) => `${val.address} ${val.province?.nameInThai} ${val.district?.nameInThai ? val.district?.nameInThai : ''} ${val.subdistrict?.nameInThai ? val.subdistrict?.nameInThai : ''} ${val.zipcode}`,
    },
    totalWeight: {
      name: 'น้ำหนักรวม',
      width: '1fr',
    },
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '1fr',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    paymentType: {
      name: 'การชำระเงิน',
      width: '8rem',
      filter: (val: string) => paymentMethodTranslate(val),
    },
    remarks: {
      name: 'หมายเหตุ',
      width: '1.5fr',
      class: 'break-words',
    },
    updatedAt: {
      name: 'แก้ไขล่าสุด',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
      class: 'text-right',
    },
  },
  sortable: [
    'orderNumber',
    'orderDate',
    'status',
    'paymentType',
    'customerName',
    'updatedAt',
  ],
};
